import '../../libs/bulma.min.css';
import './PhoneForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';

function EditPhone(props) {
  const { handleChangeInput, save, phoneModify: { idpho, phonenumber}, cancel } = props;
  return (
    <div className="phone-form-card">
      <div className="phone-form-header">
        <svg className="phone-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        <h3 className="phone-form-title">Editar Telefone</h3>
      </div>
      <form name="edit-form" id="edit-form" onSubmit={ (e) =>  e.preventDefault() }>
        <div className="phone-form-body">
          <div className="form-field-phone">
            <label className="form-label-phone">Número de telefone</label>
            <div className="form-control-phone">
              <input className="form-input-phone" name="editnumberphone" id="editnumberphone" defaultValue={ phonenumber } type="text" onChange={(e) => handleChangeInput(e.target, idpho)} placeholder="Apenas números"/>
              <p name="editnumberphone-invalid-data" className='form-error-phone is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</p>
            </div>
          </div>
        </div>
        <div className="phone-form-actions">
          <button className="btn-phone-action btn-save" type="submit" onClick={ () => save() }>
            <FontAwesomeIcon icon={ faSave } fixedWidth />
            <span>Alterar</span>
          </button>
          <button className="btn-phone-action btn-cancel" type="button" onClick={ () => cancel() }>
            <FontAwesomeIcon icon={ faArrowAltCircleLeft } fixedWidth />
            <span>Cancelar</span>
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditPhone;
